import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';

import { AppService } from './core/services/base.service';
import { LoggingService } from './core/services/log.service';
import { AuthService } from './core/services/auth.service';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { UrlSerializer } from '@angular/router';
import { SafeUrlSerializer } from './core/safe-url-serializer';

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserAnimationsModule, // required for ng2-tag-input
        CoreModule,
        LayoutModule,
        SharedModule.forRoot(),
        RoutesModule,
        ModalModule.forRoot(),
        TranslateModule.forRoot()
    ], providers: [AppService, LoggingService, AuthService, BsModalService, provideHttpClient(withInterceptorsFromDi()), { provide: UrlSerializer, useClass: SafeUrlSerializer }, provideTranslateHttpLoader()] })
export class AppModule { }
